import { ToppingsEnum } from '../toppings_defs';
import GuessBox from './GuessBox';
import './guess-row.css';

interface GuessRowProps {
    toppings: (ToppingsEnum | undefined)[];
    isUserInput?: boolean;
}

function GuessRow(props: GuessRowProps) {
    const { toppings, isUserInput } = props;
    return (
        <div className="guess-row">
            <GuessBox
                topping={toppings && toppings?.[0]}
                isUserInput={isUserInput}
            />
            <GuessBox
                topping={toppings && toppings?.[1]}
                isUserInput={isUserInput}
            />
            <GuessBox
                topping={toppings && toppings?.[2]}
                isUserInput={isUserInput}
            />
            <GuessBox
                topping={toppings && toppings?.[3]}
                isUserInput={isUserInput}
            />
        </div>
    );
}

export default GuessRow;
